import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';
import {FiltersService} from "../filters/filters.service";
import { CatalogueService } from 'app/components/catalogue/catalogue.service';

@Component({
    selector: 'email-modal',
    templateUrl: './email-modal.component.html',
    styleUrls: ['./email-modal.component.scss']
})
export class EmailModalComponent implements OnInit {

    @Input() parentId: number;
    @Input() exhibitorEmail: string = '';

    email = {
        to: '',
        name: '',
        subject: '',
        text: '',
        from: '',
        captchaResponse: ''
    };
    longText:string;
    editorConfig: Editor;
    toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
        ['link', 'image'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
      ];
    errorMessage = '';
    okMessage: string = '';
    sent: boolean = false;

    captchaOK: boolean = false;


    activateCaptcha: boolean = true;
    protected aFormGroup: FormGroup;


    constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private filtersService: FiltersService,
      public catalogueService: CatalogueService) {
        this.editorConfig = new Editor();
    }

    /**
     * [cancel: Dismisses this modal]
     */
    cancel() {
        this.activeModal.dismiss({canceled: true});
    }

    /**
     * [ok: Returns the user object to the opener]
     */
    ok() {
        this.activeModal.close(this.email);
    }

    onSubmit() {
        if (this.aFormGroup.valid) {
            this.ok();
        } else {
            this.cancel();
        }
    }

    onCaptchaResolved(response: string) {
        this.aFormGroup.controls['recaptcha'].setValue(response);
        this.email.captchaResponse = response;
        this.captchaOK = true;
    }

    ngOnInit() {
        this.aFormGroup = this.fb.group({
                recaptcha: ['', Validators.required]
        });
    }

    autoCloseModal(miliseconds: number){
        setTimeout(() => {
            this.activeModal.close();
        }, miliseconds);
    }

    ngOnDestroy(): void {
        this.editorConfig.destroy();
    }
}
